export default {
    logo: require("./logo.png"),
    logoWhite: require("./logo-white.png"),
    logoDef: require("./logo_def.png"),
    homePreview: require("./home-preview.png"),
    dropdownIcon: require("./dropdown-icon.svg"),
    caret: require("./caret.svg"),
    caretLeft: require("./caret-left.svg"),
    browser: require("./browser.png"),
    copy: require("./copy.png"),
    qr: require("./qr.png"),
    verified: require("./verified.png"),
    noImage: require("./no-image.jpg"),
    // Home
    fingerprintArtworkSlide: require("./home/fingerprint-artwork-slide.png"),
    aboutBackground: require("./home/about-background.png"),
    giveTakeBackground: require("./home/give-take.png"),
    connectionsBackground: require("./home/connections.png"),
    bgTestimonials: require("./home/bg_testimonials.png"),

    homeInline1: require("./home/inline-1.png"),
    homeInline2: require("./home/inline-2.png"),
    homeInline3: require("./home/inline-3.png"),
    homeRectangle: require("./home/Rectangle 23.png"),
    homeSculpt: require("./home/sculpt.png"),
    dataIcon: require("./home/icons/data.svg"),
    touchIcon: require("./home/icons/touch.svg"),
    cryptIcon: require("./home/icons/crypt.svg"),
    loading: require("./home/icons/loading.svg"),
    loadingWhite: require("./home/icons/loading-white.svg"),
    success: require("./home/icons/success.png"),
    fail: require("./home/icons/fail.png"),

    //Team
    lorenzoQuinn: require("./home/team/lorenzo-quinn.png"),
    nicholasQuinn: require("./home/team/nicholas-quinn.jpg"),
    ivanMelo: require("./home/team/ivan-melo.png"),
    hiramAragon: require("./home/team/hiram-aragon.png"),
    norgeVizeay: require("./home/team/norge-vizeay.png"),
    javierCabrera: require("./home/team/javier-cabrera.png"),

    //Footer
    loginButton: require("./login-button.png"),
    registerButton: require("./register-button.png"),

    //Payment
    paypal: require("./art-details/payment/paypal.png"),
    stripe: require("./art-details/payment/stripe.png"),
};



// WEBPACK FOOTER //
// ./src/assets/images/index.ts